//import request from '@/utils/request'

import {request} from './aTable_Data.js'

//查询产品列表
export function Get_Table_Data(query) {
    
  return request({
    url: 'TableData',
    method: 'get',
    params: query

  })
}



// WEBPACK FOOTER //
// ./src/api/aTable/aTable.js